import { Injectable, effect, signal } from '@angular/core';

export interface AccentPalette {
  '--brand-50': string;
  '--brand-100': string;
  '--brand-200': string;
  '--brand-300': string;
  '--brand-500': string;
  '--brand-600': string;
  '--brand-700': string;
  '--brand-800': string;
  '--brand-ink': string;
}

export const ACCENTS: Record<string, AccentPalette> = {
  blue: {
    '--brand-50': '#EAF1FF',
    '--brand-100': '#D6E4FF',
    '--brand-200': '#A9C3FF',
    '--brand-300': '#6E99FF',
    '--brand-500': '#1A62E8',
    '--brand-600': '#0052CC',
    '--brand-700': '#003FA3',
    '--brand-800': '#0A1F5C',
    '--brand-ink': '#0A1F5C',
  },
  indigo: {
    '--brand-50': '#EEEEFB',
    '--brand-100': '#DCDCF7',
    '--brand-200': '#B7B8EE',
    '--brand-300': '#8688E0',
    '--brand-500': '#4648C7',
    '--brand-600': '#2A2DAF',
    '--brand-700': '#1C1E87',
    '--brand-800': '#0E0F4D',
    '--brand-ink': '#0E0F4D',
  },
  graphite: {
    '--brand-50': '#EEF1F4',
    '--brand-100': '#DCE1E8',
    '--brand-200': '#B4BECB',
    '--brand-300': '#7E8B9E',
    '--brand-500': '#3F4C60',
    '--brand-600': '#263346',
    '--brand-700': '#16202E',
    '--brand-800': '#0A1119',
    '--brand-ink': '#0A1119',
  },
  teal: {
    '--brand-50': '#E3F4F4',
    '--brand-100': '#C2E6E6',
    '--brand-200': '#8ECBCB',
    '--brand-300': '#4FA4A4',
    '--brand-500': '#1F7F7F',
    '--brand-600': '#0D5E5E',
    '--brand-700': '#064848',
    '--brand-800': '#022828',
    '--brand-ink': '#022828',
  },
};

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly accent = signal<string>(localStorage.getItem('pec_accent') || 'blue');

  constructor() {
    effect(() => this.applyAccent(this.accent()));
  }

  setAccent(name: string) {
    this.accent.set(name);
    localStorage.setItem('pec_accent', name);
  }

  private applyAccent(name: string) {
    const palette = ACCENTS[name] ?? ACCENTS['blue'];
    Object.entries(palette).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
  }

  getAccentColor(name: string): string {
    return ACCENTS[name]?.['--brand-600'] ?? '#0052CC';
  }

  get accentNames(): string[] {
    return Object.keys(ACCENTS);
  }
}
